import React from 'react';
import { withInject } from '@piwikpro/platform';
import {
  Text,
  withTranslation,
  Stack,
  Card,
  AutoSavedSwitcherControl,
} from '@piwikpro/ui-components';
import { TrackerSettings, TrackerSettingsAttributes, TrackerSettingsResponse } from '../../../TrackerSettings';
import FailMessage from '../../GlobalAppSettings/FailMessage';

export interface NewSessionOnCampaignChangeProps {
  settings: TrackerSettingsResponse
  trackerSettings: TrackerSettings
  failed: boolean
  t: (key: string) => string
}

export class NewSessionOnCampaignChange extends React.Component<NewSessionOnCampaignChangeProps> {
  constructor(props: NewSessionOnCampaignChangeProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: Partial<TrackerSettingsAttributes>, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: any) {
    const { trackerSettings, settings } = this.props;

    try {
      await trackerSettings.updateSettings(values);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        'create_new_visit_when_campaign_changes',
        settings.attributes.create_new_visit_when_campaign_changes,
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const { settings, failed, t } = this.props;

    return (
      <Card.Section>
        <Stack wrap verticalAlignment="center">
          <Stack.Item fill>
            <Stack vertical spacing="narrow">
              <Stack.Item>
                <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">
                  {t('apps.details.settings.tracking.create-new-visit-when-campaign-changes.title')}
                </Text>
              </Stack.Item>
              <Stack.Item>
                <Text as="p">
                  {t('apps.details.settings.tracking.create-new-visit-when-campaign-changes.description')}
                </Text>
              </Stack.Item>
            </Stack>
          </Stack.Item>
          {!failed && (
            <Stack.Item>
              <AutoSavedSwitcherControl
                id="app-settings-tracking-new-session-on-campaign-change"
                initialValue={settings.attributes.create_new_visit_when_campaign_changes}
                name="create_new_visit_when_campaign_changes"
                onSubmit={this.handleSubmit}
              />
            </Stack.Item>
          )}
        </Stack>
        {failed && <FailMessage condensed />}
      </Card.Section>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
})(withTranslation(['administration'])(NewSessionOnCampaignChange as any));
